import { Outlet } from 'react-router-dom';
import NetworkConnectionAlert from '../../components/NetworkConnectionAlert';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
    <>
        <Outlet />
    </>
);

const AuthMinimalLayout = () => (
    <>
        <Outlet />
        <NetworkConnectionAlert bottom />
    </>
);

export { MinimalLayout, AuthMinimalLayout };
